import { defineComponent as s, useCssModule as r, createBlock as n, openBlock as o, resolveDynamicComponent as l, normalizeClass as c, unref as d, withCtx as u, renderSlot as C } from "vue";
const m = "cdr-card", i = /* @__PURE__ */ s({
  name: "CdrCard",
  __name: "CdrCard",
  props: {
    /** Sets valid HTML container element tag. */
    tag: {
      type: String,
      default: "article"
    }
  },
  setup(e) {
    const t = r();
    return (a, p) => (o(), n(l(e.tag), {
      class: c(d(t)[m])
    }, {
      default: u(() => [C(a.$slots, "default")]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  i as default
};
